<template>
  <v-dialog v-model="visible" max-width="750" persistent>
    <v-card>
      <v-card-title class="text-h6"> {{ isEdit ? 'Ändra fakta' : 'Ny fakta' }}</v-card-title>

      <v-card-text>
        <v-text-field
          label="Titel"
          clearable
          hide-details="true"
          outlined
          v-model="title_sve"
        ></v-text-field>
        <v-textarea class="mt-2" outlined rows="4" label="Plats" v-model="text_sve"></v-textarea>
      </v-card-text>

      <v-card-actions>
        <v-btn v-if="isEdit" color="red" text @click="onDelete"> Radera fakta </v-btn>
        <v-spacer></v-spacer>
        <v-btn text @click="onClose"> Avbryt </v-btn>
        <v-btn
          color="primary"
          v-if="isEdit"
          :disabled="!title_sve"
          :loading="loading"
          @click="onUpdate"
        >
          Uppdatera
        </v-btn>
        <v-btn
          color="primary"
          v-if="!isEdit"
          :disabled="!title_sve"
          :loading="loading"
          @click="onSave"
        >
          Spara
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'FactsEdit',
  props: {
    loading: {
      type: Boolean,
    },
    id: {
      type: [String, Number],
      required: false,
    },
  },
  data() {
    return {
      visible: true,
      title_sve: '',
      text_sve: '',
    }
  },
  computed: {
    ...mapGetters('ArterFacts', { getFactById: 'getById' }),
    isEdit() {
      return !!this.id
    },
    artId() {
      return +this.id
    },
  },
  methods: {
    ...mapActions('arterFacts', {
      getSingleFact: 'read',
    }),
    onUpdate() {
      this.$emit('fact:update', {
        id: this.artId,
        title_sve: this.title_sve,
        text_sve: this.text_sve,
      })
      this.onClose()
    },
    onSave() {
      this.$emit('fact:save', { title_sve: this.title_sve, text_sve: this.text_sve })
      this.onClose()
    },
    onDelete() {
      this.$emit('fact:delete', { id: this.artId })
      this.onClose()
    },
    onClose() {
      this.$router.replace({ name: 'ArterFacts' })
    },
  },
  async created() {
    if (this.isEdit) {
      const fact = await this.getSingleFact({ id: this.id })
      this.title_sve = fact.title_sve
      this.text_sve = fact.text_sve
    }
  },
}
</script>

<style lang="less" scoped></style>
